export default __webpack_public_path__ + "static/9117contact-8936a8f52be837bcc452c1054bd98d77.jpg";